module.exports = __webpack_public_path__ + "static/stack-8051d4d8a223ef5e6f45b26370212d71.png";